import { render, staticRenderFns } from "./CourseSingupModal.vue?vue&type=template&id=83b42544&scoped=true&"
import script from "./CourseSingupModal.vue?vue&type=script&lang=js&"
export * from "./CourseSingupModal.vue?vue&type=script&lang=js&"
import style0 from "./CourseSingupModal.vue?vue&type=style&index=0&id=83b42544&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b42544",
  null
  
)

export default component.exports